import React from "react";
import { Ticket } from "../../../../../models/Ticket";
import { getTicketStatusSummary, isTicketInactive } from "../../../../../utils/TicketPassHelper";
import { useTranslation } from "react-i18next";
import EAAlert from "../../../../shared/EAAlert";
import EAButton from "../../../../shared/Buttons/EAButton";

interface IProps {
  ticket: Ticket;
  onSelectExercise?: () => void;
}

const DetailsAlert: React.FC<IProps> = ({ ticket, onSelectExercise }) => {
  const { t } = useTranslation();
  const status = getTicketStatusSummary(ticket, t);

  const shouldShowAlert =
    status.isExpired || status.isInactive || status.isValidityEndingSoon || status.hasEntranceWarning;

  if (!shouldShowAlert) {
    return null;
  }

  const isError = status.color === "error";
  const alertVariant = isError ? "default" : "chip";

  return (
    <div>
      <EAAlert
        type={status.color === "error" ? "error" : status.color === "warning" ? "warning" : "success"}
        message={status.message}
        compact={false}
        variant={alertVariant}
      />
      {isTicketInactive(ticket) && (
        <div style={{ marginTop: "12px" }}>
          <EAButton title={t("wybierz_termin")} variant="filled" onClick={onSelectExercise || (() => {})} fullWidth />
        </div>
      )}
    </div>
  );
};

export default DetailsAlert;